var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mountains") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09-Image-/-01-Square-/-Add-/-In-active",
    transform: "translate(-51.000000, -40.000000)",
    stroke: "#C2CCD1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6102699,43.7236178 L61.6112302,43.7251179 C61.2120314,43.1039496 60.7212863,43.1109468 60.3385685,43.7416127 L51.6884047,57.9958844 C51.3144701,58.6120768 51.5027708,58.9474086 52.2164499,58.9474086 L66.7481866,58.9470128 L74.1758929,59.000185 L77.8275662,58.9633396 C78.5202905,58.95635 78.6746809,58.6582793 78.2760946,58.0828845 L72.6603721,49.976089 C72.23452,49.3613336 71.7129305,49.3771087 71.3305343,50.0109383 L68.5532714,54.6122771 L61.6102699,43.7236178 Z M75.6998214,40.5 L75.3,40.5 L75.3,43.3 L72.5,43.3 L72.5,43.7 L75.3,43.7 L75.3,46.5 L75.6998215,46.5 L75.6988214,43.6988214 L78.5,43.6998215 L78.5,43.3 L75.6988214,43.3 L75.6998214,40.5 Z",
    id: "Mountains"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.99187dfd3448eb22361bc65c8d6da087.svg";
export { ForwardRef as ReactComponent };